import React, { useState, useEffect, forwardRef } from "react";
import IEditableProps from "../../utilities/IEditableProps";
import IStyledProps from "../../utilities/IStyledProps";
import classNames from "classnames";

interface IAccordionProps extends IEditableProps, IStyledProps {
    children: any;
    defaultOpen?: number;
}

const Accordion = forwardRef(({ defaultOpen, children, cmsId, editorClassObj }: IAccordionProps, ref: any) => {
    const [openSection, setOpenSection] = useState(defaultOpen);

    useEffect(() => {
        setOpenSection(defaultOpen);
    }, [defaultOpen]);

    function onOpen(id) {
        setOpenSection(id);
    }

    function onClose() {
        setOpenSection(null);
    }

    return (
        <div data-id={cmsId} ref={ref as any} className={classNames("accordion", editorClassObj)}>
            {React.Children.map(children,
                child => {
                    if (child) {
                        return React.cloneElement(child, {
                            onOpen,
                            onClose,
                            open: openSection === child.props.id
                        });
                    }
                })
            }
        </div>
    );
});

export default Accordion;
(global as any).Accordion = Accordion;